// Dashboard data changes throughout the day, but it does not need second-by-second updates.
// These intervals keep the screen feeling current without leaving constant listeners open.
export const DASHBOARD_ACTIVITY_REFRESH_MS = 2 * 60 * 1000
export const DASHBOARD_ADOPTION_REFRESH_MS = 15 * 60 * 1000
